import type { ZodType } from 'zod';

import { icsApi } from './api';

interface Params<T> {
  url: string;
  schema: ZodType<T>;
  signal?: AbortSignal;
}

export async function get<T>({ url, schema, signal }: Params<T>): Promise<T> {
  const axiosResponse = await icsApi.get(url, { signal });

  const response = schema.safeParse(axiosResponse.data);
  if (!response.success) {
    throw new Error(response.error.message);
  }

  return response.data;
}
